import { instance } from "@/apis";
import { AI_HOME_PATHNAME } from "@/constants/pathname";
import { useMutation, useQueryClient, InfiniteData } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import type { ChatListResponse } from "@/hooks/services/queries/ai-agent/use-chats-query";

export const useDeleteChatMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: async (chatId: string) =>
      instance.delete(`/api/df/user/chat/${chatId}`).then((res) => res.data),
    onMutate: async (chatId: string) => {
      // 서버 요청이 나가기 직전 AI_HOME_PATHNAME로 이동
      navigate(AI_HOME_PATHNAME, { replace: true });

      // Optimistic Update: 캐시에서 삭제된 채팅 제거
      const previousChats = queryClient.getQueryData<InfiniteData<ChatListResponse>>(["chats"]);

      if (previousChats?.pages) {
        queryClient.setQueryData<InfiniteData<ChatListResponse>>(["chats"], {
          ...previousChats,
          pages: previousChats.pages.map((page) => ({
            ...page,
            content: page.content.filter((chat) => chat.chatId !== chatId),
          })),
        });
      }

      return { previousChats };
    },
    onSuccess: () => {
      // invalidateQueries를 사용하지 않음
      // 다른 스트리밍 중인 채팅방이 사라지는 것을 방지
      // 캐시는 onMutate에서 이미 업데이트됨
    },
    onError: (_err, _chatId, context) => {
      // 에러 발생 시 이전 상태로 롤백
      if (context?.previousChats) {
        queryClient.setQueryData(["chats"], context.previousChats);
      }
    },
  });
};
